import React, { useState, useContext } from 'react';
import {
	TextField,
	Typography,
	Container,
	Stack,
	Button,
	Paper,
	Grid,
	InputAdornment,
	Box,
	IconButton
} from '@mui/material';
import { DataContext } from '../../../../context/DataContext';
import { simpleMessage } from '../../../../helpers/Helpers';
import { getToken } from '../../../../api/Account';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/free-regular-svg-icons';
import { Close } from '@mui/icons-material';

import { addGarantiaAsync } from '../../../../api/Credits';

const AddGarantia = ({ setShowModal, id, localReload, setLocalReload }) => {
	const [articulo, setArticulo] = useState('');
	const [marca, setMarca] = useState('');
	const [color, setColor] = useState('');
	const [modelo, setModelo] = useState('');
	const [serie, setSerie] = useState('');
	const [valorEstimado, setValorEstimado] = useState('');

	const [selectedFiles, setSelectedFiles] = useState([]);
	const [previews, setPreviews] = useState([]);

	const { setIsLoading, setIsUnautorized } = useContext(DataContext);

	const token = getToken();

	const addNewGarantia = async () => {
		if (validate()) {
			const formData = new FormData();

			formData.append('creditId', id);
			formData.append('articulo', articulo);
			formData.append('marca', marca);
			formData.append('color', color);
			formData.append('modelo', modelo);
			formData.append('serie', serie);
			formData.append('valorEstimado', valorEstimado);

			selectedFiles.forEach((photo, index) => {
				formData.append(`garantiaPhoto`, photo); // o photo si es directamente el File
			});

			if (marca === '') {
				formData.append('marca', 'S/M');
			}

			if (modelo === '') {
				formData.append('modelo', 'S/M');
			}

			if (serie === '') {
				formData.append('serie', 'S/S');
			}

			setIsLoading(true);
			const result = await addGarantiaAsync(token, formData);
			if (!result.statusResponse) {
				setIsLoading(false);
				if (result.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}
				simpleMessage(result.error, 'error');
				return;
			}
			setIsLoading(false);
			simpleMessage('Garantia Agregada...!', 'success');
			setLocalReload(!localReload);
			setShowModal(false);
		}
	};

	const validate = () => {
		let isValid = true;
		if (articulo === '') {
			simpleMessage('Debe ingresar un artículo', 'error');
			return (isValid = false);
		}

		if (color === '') {
			simpleMessage('Debe ingresar un color', 'error');
			return (isValid = false);
		}

		if (valorEstimado === '' || valorEstimado === 0) {
			simpleMessage('Debe ingresar un valor al artículo', 'error');
			return (isValid = false);
		}
		if (selectedFiles.length < 1) {
			simpleMessage('Debe seleccionar al menos una foto', 'error');
			return (isValid = false);
		}
		return isValid;
	};

	//Devuelve un entero positivo
	const funtionSetValorEstimado = (value) => {
		if (/^[0-9]+$/.test(value.toString()) || value === '') {
			setValorEstimado(value);
			return;
		}
	};

	const onChangeFile = (e) => {
		const files = Array.from(e.target.files);

		if (!files) return;

		if (files.length > 1) {
			simpleMessage('Solo puedes seleccionar máximo 1 archivo', 'error');
			e.target.value = ''; // Limpiar la selección
			return;
		}

		// Crear vistas previas
		const newPreviews = files.map((file) => ({
			file,
			preview: URL.createObjectURL(file)
		}));

		setSelectedFiles(files);
		setPreviews(newPreviews);
	};

	const removeImage = (index) => {
		// Revocar la URL para liberar memoria
		URL.revokeObjectURL(previews[index].preview);

		const newPreviews = previews.filter((_, i) => i !== index);
		const newFiles = selectedFiles.filter((_, i) => i !== index);

		setPreviews(newPreviews);
		setSelectedFiles(newFiles);
	};

	// Limpiar URLs cuando el componente se desmonte
	React.useEffect(() => {
		return () => {
			previews.forEach((preview) => URL.revokeObjectURL(preview.preview));
		};
	}, []);

	return (
		<div>
			<Container style={{ width: 550 }}>
				<Paper
					style={{
						padding: 20
					}}
				>
					<Grid container spacing={2}>
						<Grid item xs={12}>
							<Stack spacing={1} direction="row" justifyContent={'center'}>
								<Typography
									style={{
										color: '#2979ff'
									}}
								>
									CREDITO # :
								</Typography>
								<Typography
									style={{
										fontWeight: 'bold'
									}}
								>
									{id}
								</Typography>
							</Stack>
						</Grid>

						<Grid item xs={12} sm={6}>
							<Stack spacing={2}>
								<TextField
									required
									fullWidth
									onChange={(e) => setArticulo(e.target.value.toUpperCase())}
									value={articulo}
									label={'Articulo'}
								/>
								<TextField
									fullWidth
									onChange={(e) => setMarca(e.target.value.toUpperCase())}
									value={marca}
									label={'Marca'}
								/>
								<TextField
									required
									fullWidth
									onChange={(e) => setColor(e.target.value.toUpperCase())}
									value={color}
									label={'Color'}
								/>
							</Stack>
						</Grid>
						<Grid item xs={12} sm={6}>
							<Stack spacing={2}>
								<TextField
									fullWidth
									onChange={(e) => setModelo(e.target.value.toUpperCase())}
									value={modelo}
									label={'Modelo'}
								/>
								<TextField
									fullWidth
									onChange={(e) => setSerie(e.target.value.toUpperCase())}
									value={serie}
									label={'Serie'}
								/>
								<TextField
									required
									fullWidth
									onChange={(e) => funtionSetValorEstimado(e.target.value)}
									value={valorEstimado}
									label={'Valor estimado'}
									InputProps={{
										startAdornment: (
											<InputAdornment position="start">C$</InputAdornment>
										)
									}}
								/>
							</Stack>
						</Grid>

						<Grid item xs={12}>
							<TextField
								fullWidth
								type="file"
								label="Fotos del Cliente"
								inputProps={{
									accept: 'image/*' // opcional: limitar a imágenes
								}}
								onChange={onChangeFile}
							/>

							{previews.length > 0 && (
								<Box>
									{previews.map((preview, index) => (
										<Paper
											key={index}
											sx={{
												position: 'relative',
												p: 1,
												height: 200,
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'center'
											}}
										>
											<IconButton
												size="small"
												sx={{
													position: 'absolute',
													top: 8,
													right: 8,
													backgroundColor: 'rgba(255,255,255,0.8)',
													'&:hover': {
														backgroundColor: 'rgba(255,255,255,0.9)'
													}
												}}
												onClick={() => removeImage(index)}
											>
												<Close />
											</IconButton>

											<img
												src={preview.preview}
												alt={`Vista previa ${index + 1}`}
												style={{
													maxWidth: '100%',
													maxHeight: '100%',
													objectFit: 'contain'
												}}
												onLoad={() => URL.revokeObjectURL(preview.preview)}
											/>
										</Paper>
									))}
								</Box>
							)}
						</Grid>
						<Grid item xs={12}>
							<Button
								variant="outlined"
								startIcon={
									<FontAwesomeIcon icon={faSave} style={{ marginRight: 20 }} />
								}
								fullWidth
								onClick={() => addNewGarantia()}
								style={{
									color: '#00a152',
									borderColor: '#00a152'
								}}
								size="large"
							>
								Agregar garantia
							</Button>
						</Grid>
					</Grid>
				</Paper>
			</Container>
		</div>
	);
};

export default AddGarantia;
